import { DEALER_STATUS } from 'constants/StatusConstants';

const { ACTIVE } = DEALER_STATUS;

export const mergeByExtensions = (state, dealers, extension, includeInactive = false) => {
  const dealersToUpdate = dealers.filter(
    ({ extensions = [], status = ACTIVE }) => (status === ACTIVE || includeInactive) && extensions?.includes(extension)
  );
  return [...new Set([...state, ...dealersToUpdate.map(dealer => dealer.id)])];
};

export const mergeByFeatures = (state, dealers, feature, includeInactive = false) => {
  const dealersToUpdate = dealers.filter(
    ({ features = [], status = ACTIVE }) => (status === ACTIVE || includeInactive) && features?.includes(feature)
  );
  return [...new Set([...state, ...dealersToUpdate.map(dealer => dealer.id)])];
};
